import { render, staticRenderFns } from "./ReceiveNetwork.vue?vue&type=template&id=acf1df74&scoped=true&"
import script from "./ReceiveNetwork.vue?vue&type=script&lang=js&"
export * from "./ReceiveNetwork.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveNetwork.vue?vue&type=style&index=0&id=acf1df74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf1df74",
  null
  
)

export default component.exports